import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDragon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 21 21",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20.349,6.485l-3.709,0.04l0,-5.228l-3.652,3.911l-2.524,-5.208l-2.485,5.188l-3.709,-3.891l-0.153,5.228l-3.633,0l3.633,3.892c-0.058,1.017 -0.077,3.991 1.568,5.787c1.166,1.257 2.523,1.237 2.734,4.47c-0,0.06 -0,0.099 0.019,0.159l4.015,0c-0,-0.06 -0,-0.099 0.019,-0.159c0.191,-3.233 1.568,-3.213 2.734,-4.47c1.644,-1.796 1.625,-4.81 1.568,-5.807l3.575,-3.912Zm-11.28,8.142c-0,0 -3.212,-1.736 -3.365,-4.23l3.365,2.235l-0,1.995Zm2.696,0l-0,-1.995l3.365,-2.235c-0.153,2.494 -3.365,4.23 -3.365,4.23Z",
		stroke: "#93abc9",
		strokeWidth: 1,
		fill: "transparent"
	})
});
export default SvgDragon;
